import { coverSrc, servicePrice, type CatalogKind, type PublicShop } from "@fusiqo/vozqi-shared";
import { ServiceCard } from "./services-list";
import { ProductCard } from "./shop-products";
import { useMoreItems } from "./use-more-items";

/**
 * «MÁS SERVICIOS» / «MÁS PRODUCTOS»: a few more of what the
 * business offers, of the item's own kind, drawn with the profile's very
 * cards -- a service's row, a product's tile --, and «Ver todos» to the
 * profile when it lists more. Nothing else to show, and the part is not drawn.
 */
export function ItemMore({
  shop,
  slug,
  kind,
  token,
  profileHref,
}: {
  shop: PublicShop;
  slug: string;
  /** What the profile lists in this part: SERVICE, PRODUCT, or everything when it is only a shop. */
  kind: CatalogKind | null;
  token: string;
  profileHref: string;
}) {
  const more = useMoreItems(slug, kind, token);
  if (more === null || more.items.length === 0) return null;
  const services = kind === "SERVICE";
  const { country } = shop.business;
  return (
    <section className="item-more" aria-labelledby="item-more-title">
      <div className="item-more-heading">
        <h2 id="item-more-title" className="profile-section-title">
          {services ? "Más servicios" : "Más productos"}
        </h2>
        {more.more ? (
          <a className="item-more-all" href={profileHref}>
            Ver todos
          </a>
        ) : null}
      </div>
      <div className={services ? "profile-services" : "shop-grid"}>
        {more.items.map((item) =>
          services ? (
            <ServiceCard
              key={item.token}
              item={item}
              cover={coverSrc(slug, item, more.pageQuery)}
              price={servicePrice(item, country)}
            />
          ) : (
            <ProductCard key={item.token} item={item} cover={coverSrc(slug, item, more.pageQuery)} country={country} />
          ),
        )}
      </div>
    </section>
  );
}
